module.exports = __webpack_public_path__ + "israel.svg?66d49a1ac9e5e51a4d0126c552699543";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/israel.svg
// module id = 196
// module chunks = 10